import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import { queryKeys } from '@/api/queryKeys'
import type { components } from '@/../types/api'

export type Theme = components['schemas']['ThemeOut']

/**
 * List all visual themes available to the factories. Long staleTime —
 * themes are static JSON on disk, they rarely change at runtime.
 */
export function useThemes() {
  return useQuery({
    queryKey: queryKeys.themes.list(),
    queryFn: async (): Promise<Theme[]> => {
      const { data } = await api.GET('/api/v1/themes', { params: {} })
      return data?.data ?? []
    },
    staleTime: 5 * 60_000,
  })
}
